import {useTranslation} from "next-i18next";
import {FC} from "react";
import {BoxServiceCardIconTopBoxType, i18translateType,} from "../../@types/types-body";

export const BoxServiceCardIconTopBox: FC<BoxServiceCardIconTopBoxType> = ({
                                                                               id, namespace, object, iconEnum,
                                                                           }) => {
    const {t}: i18translateType = useTranslation(namespace);
    return (<>
            {Object.keys(t(`${object}`, {returnObjects: true})).map((subObject, index) => (
                <div className="basis-full lg:basis-5/12 my-4" key={index}>
                    <div
                        className="group min-w-[350px] max-w-[650px] min-h-full mx-auto border border-gray-400 rounded p-4 justify-between leading-normal z-0
      transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-120 hover:bg-white hover:shadow-2xl duration-300"
                        key={`service-card-for-${index}`}
                    >
                        <div className="mb-8">
                            <div className="flex justify-center">
          <span className="w-12 h-12 rounded-full mr-4 fill-crowlyn-light">
            {iconEnum[subObject]}
          </span>
                            </div>
                            <h3 className="mt-4 text-xl leading-none font-bold text-center text-crowlyn-mid">
                                {t(`${object}.${subObject}.title`)}
                            </h3>
                            <p className="text-gray-900 text-sm mt-5 md:text-base text-justify">
                                {t(`${object}.${subObject}.text`)}
                            </p>
                            <p className="text-gray-900 text-sm mt-5 md:text-base text-justify">
                                {t(`${object}.${subObject}.benefits`)}
                            </p>
                        </div>
                    </div>
                </div>))}
        </>);
};
